import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full p-4" }
const _hoisted_2 = { class: "text-left text-sm font-semibold" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-left text-xs font-normal text-wrap break-words" }
const _hoisted_5 = { class: "text-right text-xs font-normal pt-2 text-gray-500" }

import { computed, onMounted, ref } from 'vue';
import { Conversation, ImageSourceChoice } from '@/http/customerSession';
import { set } from '@vueuse/core';
import _ from 'lodash';
import { getBlobById } from '@/http/blob';
import { useStore } from 'vuex';
import { GET_CREDENTIALS } from '@/store';
import { validateBase64 } from '@/lib/formValidation';

export interface ChatSessionInput {
    displayName: string;
    conversation: Conversation;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatConversation',
  props: {
    input: {}
  },
  setup(__props: any) {

const text = ref<string | undefined>();

const setText = (input: ChatSessionInput) => {
    if (input.conversation.sender === 'BOT') {
        if (input.conversation.workflowTask == undefined) return;
        set(text, input.conversation.workflowTask.type === 'image' ?
            input.conversation.workflowTask.caption ?? ''
            : input.conversation.workflowTask.content ?? 'Esta mensagem não está disponível'
        );
        return;
    }
    if (input.conversation.message?.text == undefined) return;
    set(text, input.conversation.message?.text);
};

const props = __props;

const sender = computed(() => {
    if (props.input.conversation.sender === 'BOT') {
        return 'Chatbot';
    }
    if (props.input.conversation.sender === 'CUSTOMER') {
        return props.input.displayName;
    }
    return 'Atendente';
});

const isDateOlderThan24h = (date: Date) => {
    const now = new Date();
    const dateToCompare = new Date(date);
    const difference = now.getTime() - dateToCompare.getTime();
    const _24_HOURS_IN_MS = 24 * 60 * 60 * 1000;
    return difference > _24_HOURS_IN_MS;
};

const getFormattedTime = (date: Date) => {
    return `${_.padStart(date.getHours().toString(), 2, '0')}:${_.padStart(date.getMinutes().toString(), 2, '0')}`;
};

const getFormattedDateTime = () => {
    let date = new Date(props.input.conversation.dateTime);
    if (isDateOlderThan24h(date)) {
        return `${date.toLocaleDateString()} às ${getFormattedTime(date)}`;
    }
    return getFormattedTime(date);
};

const imageSrc = ref<string | undefined>();
const imageContentType = ref<string | undefined>();
const imageSource = ref<ImageSourceChoice | undefined>();

const { getters } = useStore();

const setImage = async (conversation: Conversation) => {
    if (conversation.message?.imageContent == undefined) return;
    let src: string | undefined;
    let source: ImageSourceChoice | undefined;
    if (conversation.sender === 'CUSTOMER') {
        src = conversation.message?.imageContent;
    } else if (conversation.sender === 'BOT') {
        if (conversation.workflowTask?.type !== 'image') return;
        source = conversation.workflowTask?.imageSource;
        src = conversation.workflowTask?.content;
    } else {
        src = conversation.message.imageContent;
        source = conversation.message.imageSourceChoice;
    }
    if (source !== 'URL') {
        const blob = await getBlobById(src, getters[GET_CREDENTIALS]);
        if (!validateBase64(blob.base64Encoded)) return;
        src = `data:${blob.contentType?.toLowerCase()};charset=utf-8;base64, ${blob.base64Encoded}`;
        set(imageContentType, blob.contentType);
        set(imageSource, 'BASE64');
    }
    set(imageSrc, src);
};

onMounted(async () => {
    setText(props.input);
    setImage(props.input.conversation);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center space-x-2 w-full", {
                'flex-row': _ctx.input.conversation.sender === 'CUSTOMER',
                'flex-row-reverse': _ctx.input.conversation.sender !== 'CUSTOMER',
            }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({
                'flex flex-col ml-2 rounded-xl text-black-700 p-3 max-w-xl': true,
                'bg-bot-message opacity-60 rounded-tr-none': _ctx.input.conversation.sender === 'BOT',
                'bg-support-message rounded-tr-none': _ctx.input.conversation.sender === 'SUPPORT' && _ctx.input.conversation.target === 'CHAT',
                'bg-internal-message rounded-tr-none': _ctx.input.conversation.target === 'INTERNAL',
                'bg-customer-message rounded-tl-none': _ctx.input.conversation.sender === 'CUSTOMER',
            })
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(sender.value) + ":", 1),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full mb-2", { hidden: imageSrc.value === undefined }])
        }, [
          _createElementVNode("img", {
            src: imageSrc.value,
            class: "bg-cover max-w-md h-auto rounded-xl mix-blend-normal",
            alt: "Imagem enviada na conversa"
          }, null, 8, _hoisted_3)
        ], 2),
        _createElementVNode("p", _hoisted_4, _toDisplayString(text.value), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(getFormattedDateTime()), 1)
      ], 2)
    ], 2)
  ]))
}
}

})